import { forwardRef } from 'react'
import { cn } from '../../lib/cn.js'

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean
}

/** The multi-line control. Resizes vertically only — sideways breaks every layout. */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, invalid, rows = 4, ...props },
  ref,
) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      aria-invalid={invalid || undefined}
      className={cn(
        'w-full box-border resize-y rounded-md border bg-surface px-4 py-3 text-body text-ink',
        'placeholder:text-ink-muted outline-none transition-colors',
        'focus-visible:border-coral-fill focus-visible:ring-2 focus-visible:ring-coral-fill/25',
        'disabled:bg-sunk disabled:text-ink-muted disabled:cursor-not-allowed',
        invalid
          ? 'border-error focus-visible:border-error focus-visible:ring-error/25'
          : 'border-hairline-strong',
        className,
      )}
      {...props}
    />
  )
})
